<div class="modal" (click)="clickOuside()">
    <div class="modal-content" (click)="stopPropagation($event)">
        <div class="modal-header"> {{ header }} </div>
        <form [formGroup]="memoFormGroup" (ngSubmit)="onSubmit()">
            <div class="modal-subtitle">
                <div class="destinataires">
                    <p>Destinataire(s)</p>
                    <div class="error-message-container">
                        <ng-select *ngIf="mode === 'create'" #select formControlName="receiver"
                            placeholder="Sélectionner un destinataire" [multiple]="true" [appendTo]="'body'">
                            <ng-option *ngFor="let user of usersName" [value]="user.id">{{user.name}}</ng-option>
                        </ng-select>
                        <div
                            *ngIf="mode === 'create' && memoFormGroup.get('receiver').invalid && memoFormGroup.get('receiver').touched ">
                            <div class="error-message" *ngIf="!!memoFormGroup.get('receiver').hasError('required')">
                                Veuillez sélectionner un destinataire (à minima vous-même). </div>
                        </div>
                    </div>
                    <p *ngIf="mode != 'create'" class="destinataires-edit">{{usersName}}</p>
                </div>
                <div class="infos-memo">
                    <p>Créé par {{ authorName }}</p>
                    <p *ngIf="mode != 'editPage'">le {{ date | date: 'dd/MM/yyyy' }}</p>
                    <p *ngIf="mode === 'editPage'">le {{ date }}</p>
                </div>
            </div>
            <div class="modal-body">
                <textarea formControlName="msg"></textarea>
                <div class="button-wrapper">
                    <frg-button *ngIf="mode != 'create' && !noEdit" [type]="button" (mousedown)="disabledMemo()"
                        [backgroundColor]="'var(--darkest-primary)'">
                        Supprimer
                    </frg-button>
                    <frg-button *ngIf="mode != 'create' && !noEdit" [type]="button" (mousedown)="processedMemo()"
                        [backgroundColor]="'var(--primary)'">
                        Traiter
                    </frg-button>
                    <frg-button type="submit" [disabled]="memoFormGroup.get('msg').invalid" *ngIf="!noEdit">Enregistrer
                    </frg-button>
                    <frg-button [type]="'reset'" (activated)="closeMemoModal()"
                    [backgroundColor]="'var(--darkest-primary)'">Fermer
                </frg-button>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="modal-background"></div>